export const fuseNavigationConfig = [
  {
    id: 'applications',
    title: 'Applications',
    type: 'group',
    icon: 'apps',
    children: [
      {
        id: 'users',
        title: 'Role Setting',
        type: 'item',
        icon: 'settings',
        url: '/users',
      },
      {
        id: 'ai',
        title: 'AI Setting',
        type: 'item',
        icon: 'chat_bubble_outline',
        url: '/ai',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseNavigationConfig.js